import React, {Component} from "react"
import PropTypes from "prop-types"
import {translate} from "react-i18next"

import {Container, Row, Col} from "../Grid"
import Button from "../Button"

import SingleChoice from "./SingleChoice"
import MultipleChoice from "./MultipleChoice"
import Star from "./Star"
import Text from "./Text"
import styles from "./styles.css"

class Feedback extends Component {
  static propTypes = {
    intro: PropTypes.string,
    outro: PropTypes.string,
    questions: PropTypes.arrayOf(PropTypes.object),
    submitResponse: PropTypes.func,
    closeModal: PropTypes.func,
    topicName: PropTypes.string,
    active: PropTypes.bool
  }

  static defaultProps = {
    intro: null,
    outro: null,
    questions: [],
    submitResponse: _data => {},
    closeModal: () => {},
    topicName: "",
    active: false
  }

  constructor(props) {
    super(props)

    this.initialState = this.state = {
      currentStep: "intro",
      currentQuestion: 0,
      data: {}
    }

    this._updateData = this._updateData.bind(this)
  }

  _updateStep(step) {
    this.setState(prevState => {
      return {
        ...prevState,
        currentStep: step
      }
    })
  }

  _updateQuestion(index) {
    this.setState(prevState => {
      return {
        ...prevState,
        currentQuestion: index
      }
    })
  }

  _updateData(data) {
    this.setState(prevState => {
      return {
        ...prevState,
        data: {
          ...prevState.data,
          ...data
        }
      }
    })
  }

  _closeModalAndResetState() {
    this.props.closeModal()

    setTimeout(() => {
      this.setState(_prevState => {
        return this.initialState
      })
    }, 1000)
  }

  _isQuestionValueEmpty(question) {
    if (
      typeof this.state.data[`question_${question.id}`] === "undefined" ||
      this.state.data[`question_${question.id}`] === "" ||
      (this.state.data[`question_${question.id}`].constructor === String &&
        this.state.data[`question_${question.id}`].trim() === "")
    )
      return true

    return false
  }

  renderIntro() {
    const {intro, t} = this.props

    return (
      <div className={styles.Intro}>
        <div className="text" dangerouslySetInnerHTML={{__html: intro}} />
        <div className="button-row">
          <Button theme="purple" onClick={() => this._updateStep("question")}>
            {t("Weiter")}
          </Button>
        </div>
      </div>
    )
  }

  renderOutro() {
    const {outro, t} = this.props

    return (
      <div className={styles.Outro}>
        <div className="text" dangerouslySetInnerHTML={{__html: outro}} />
        <div className="button-row">
          <Button
            theme="purple"
            onClick={() => this._closeModalAndResetState()}
          >
            {t("Schließen")}
          </Button>
        </div>
      </div>
    )
  }

  renderQuestionType(question) {
    switch (question.type) {
      case "text":
        return <Text question={question} onChange={this._updateData} />

      case "multiple_choice":
        return (
          <MultipleChoice question={question} onChange={this._updateData} />
        )

      case "star":
        return <Star question={question} onChange={this._updateData} />

      case "single_choice":
      default:
        return <SingleChoice question={question} onChange={this._updateData} />
    }
  }

  renderQuestion() {
    const {submitResponse, questions, t} = this.props
    const {currentQuestion, data} = this.state

    const question = questions[currentQuestion]

    return (
      <div className={styles.Question}>
        <div className="title">
          <span className="title__index">
            {t("Frage {{index}}", {index: currentQuestion + 1})}
          </span>
          <div
            className="title__question"
            dangerouslySetInnerHTML={{__html: question.title}}
          />
        </div>
        <div className="input-row">{this.renderQuestionType(question)}</div>
        {question.is_mandatory && (
          <div className="mandatory">
            {t("Bitte beantworten Sie diese Frage, um fortzufahren.")}
          </div>
        )}
        <div className="button-row">
          {questions.length > currentQuestion + 1 ? (
            <Button
              disabled={
                question.is_mandatory
                  ? this._isQuestionValueEmpty(question)
                  : false
              }
              theme="purple"
              onClick={() => this._updateQuestion(currentQuestion + 1)}
            >
              {t("Weiter")}
            </Button>
          ) : (
            <Button
              disabled={
                question.is_mandatory
                  ? this._isQuestionValueEmpty(question)
                  : false
              }
              theme="purple"
              onClick={() => {
                // submit data
                submitResponse(data)

                // update step to outro
                this._updateStep("outro")
              }}
            >
              {t("Weiter")}
            </Button>
          )}
        </div>
      </div>
    )
  }

  renderContent() {
    switch (this.state.currentStep) {
      case "intro":
        return this.renderIntro()

      case "outro":
        return this.renderOutro()

      default:
        return this.renderQuestion()
    }
  }

  renderSteps() {
    const {questions} = this.props
    const {currentStep, currentQuestion} = this.state

    const steps = ["intro", "outro"]

    // insert questions into steps
    questions.forEach((_question, _index) => {
      steps.splice(1, 0, "question")
    })

    return (
      <ul>
        {steps.map((step, index) => {
          switch (step) {
            case "intro":
              return (
                <li
                  key={`step-${index}`}
                  className={currentStep === "intro" ? "active" : null}
                >
                  <i className="icon icon-comment-blank" />
                </li>
              )

            case "outro":
              return (
                <li
                  key={`step-${index}`}
                  className={currentStep === "outro" ? "active" : null}
                >
                  <i className="icon icon-quiz-feedback-right" />
                </li>
              )

            case "question":
            default:
              return (
                <li
                  key={`step-${index}`}
                  className={
                    currentStep === "question" && currentQuestion === index - 1
                      ? "active"
                      : null
                  }
                >
                  {index}
                </li>
              )
          }
        })}
      </ul>
    )
  }

  render() {
    const {active, topicName, t} = this.props

    return (
      <div className={`${styles.Modal} ${active ? "active" : null}`}>
        <div className={styles.Header}>
          <Container>
            <Row>
              <Col className="header__content">
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("Feedback zu Kurs: <b>{{topicName}}</b>", {
                      topicName
                    })
                  }}
                />
                <button
                  onClick={() => this._closeModalAndResetState()}
                  className="header__button"
                >
                  <i className="icon icon-quiz-fail-box" />
                </button>
              </Col>
            </Row>
          </Container>
        </div>
        <div className={styles.Steps}>
          <Container>
            <Row>
              <Col className={styles.StepsContent}>{this.renderSteps()}</Col>
            </Row>
          </Container>
        </div>
        <div className={styles.Content}>
          <Container>
            <Row>
              <Col>{this.renderContent()}</Col>
            </Row>
          </Container>
        </div>
      </div>
    )
  }
}

export default translate()(Feedback)



// WEBPACK FOOTER //
// ./src/components/Feedback/index.js